export default {
  name: 'Parsely My Sport',
  htmlId: 'parselyMySport',
};
